import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { getUserRole } from '../../common/utils/convert';
import { UserDTO } from '../../services/types/apiType';
import { UserType } from '../../common/enum';

export const parseUserData = (attributeList: CognitoUserAttribute[]) => {
  const user: UserDTO = {
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    avatar: '',
    phone: '',
    address: { streetAddress1: '', streetAddress2: '', state: '', country: '', postcode: '', city: '' },
    language: 'en-EN',
    userType: UserType.USER,
  };

  attributeList.forEach((attribute: CognitoUserAttribute) => {
    switch (attribute.Name) {
      case 'sub':
        user.id = attribute.Value;
        break;
      case 'email':
        user.email = attribute.Value;
        break;
      case 'phone_number':
        user.phone = attribute.Value;
        break;
      case 'given_name':
        user.firstName = attribute.Value;
        break;
      case 'family_name':
        user.lastName = attribute.Value;
        break;
      case 'custom:avatar':
        user.avatar = attribute.Value;
        break;
      case 'address':
        user.address = JSON.parse(attribute.Value);
        break;
      case 'locale':
        user.language = attribute.Value;
        break;
      case 'custom:user_type':
        user.userType = getUserRole(attribute.Value);
        break;
      default:
        break;
    }
  });
  return user;
};
